import { render, staticRenderFns } from "./IconPlaces.vue?vue&type=template&id=84c98e64&"
import script from "./IconPlaces.vue?vue&type=script&lang=js&"
export * from "./IconPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports